export default {
  items: {},
  loading: false,
  creatingRest: false,
};
